import { IntlFormatters } from 'react-intl'
import { AssessmentLevelNamesType, AssessmentType } from '../types/resourceExplorer'

export const getTranslationKeysForLevels = (
  assessmentType: AssessmentType,
  levels: number,
  formatMessage: IntlFormatters['formatMessage'],
  levelNamesType?: AssessmentLevelNamesType,
) => {
  if (assessmentType === AssessmentType.BaselineAssessment) {
    return Array.from(Array(5).keys()).map(i =>
      formatMessage({ id: 'baselineAssessment.totalLevel' }, { value: i + 1 }),
    )
  }

  if (assessmentType === AssessmentType.Flexible) {
    return Array.from(Array(levels).keys()).map(i =>
      formatMessage({ id: `assessments.${levelNamesType}WithPercentageSpan.${levels}.level${i + 1}` }),
    )
  }

  return Array.from(Array(levels).keys()).map(i =>
    formatMessage({ id: `assessments.IntervalsWithPercentageSpan.${levels}.level${i + 1}` }),
  )
}
